export function formattedDate(dateText: string | undefined) {
  const isoDate = `${dateText}`;

  // Create a Date object from the ISO string
  const date = new Date(isoDate);
  const day = date.getUTCDate();
  const month = date.getUTCMonth() + 1; // Adding 1 because months are zero-based
  const year = date.getUTCFullYear();

  // Format the date components to "dd/mm/yyyy"
  return `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`;
}
